import * as React from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import './dialog.css';

export default function InfoPopup() {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('s'));
    const isOpen = useStoreState((state) => state.isOpen);
    const notice = useStoreState((state) => state.notice);
    const buttonName = useStoreState((state) => state.btnName);
    const isCallBack = useStoreState((state) => state.isCallBack);
    const close = useStoreActions((actions) => actions.close);
    const callback = useStoreState((state) => state.callback);
    const isLogOutBtn = useStoreState((state) => state.isLogOutBtn);

    const handleClose = () => {
        close();
        if (isCallBack) callback();
    };

    const logout = () => {
        localStorage.removeItem('token');
        window.location.reload();
    };
    return (
        <div>
            <Dialog
                className="glass-dialog-container glass-dialog-container-two login-third"
                open={isOpen}
                onClose={handleClose}
                fullScreen={fullScreen}
            >
                <DialogTitle
                    fontSize="22px"
                >
                    {notice}
                </DialogTitle>
                <DialogContent>
                    <div>
                        <Button
                            variant="outlined"
                            color="success"
                            fullWidth
                            onClick={handleClose}
                        >
                            {buttonName}
                        </Button>
                        {isLogOutBtn ? (
                            <Button
                                variant="outlined"
                                color="warning"
                                fullWidth
                                onClick={logout}
                            >
                                Logout
                            </Button>
                        ) : ''}
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
